import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_featured_made_italy: FaireCategoryEntity = {
  token: "cat_featured-made-italy",
  type: "category",
  name: "Made in Italy",
  level: 2,
  parentToken: "cat_featured-brands",
  href: "/category/made-in-italy",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
